import { Container } from 'src/components/Container/Container'
import { ProductCard } from 'src/components/ProductCard/ProductCard'
import { ProductCardLarge } from 'src/components/ProductCard/ProductCardLarge'

import styles from './ProductGrid.module.scss'

import type { Product } from 'src/data/graphql-generated'
import type { ProductRating } from 'src/types/Product'

export interface ProductGridProps {
  products: Product[]
  largeCardProductIds?: string[]
  ratings: Record<string, ProductRating>
  showVariants?: boolean
  preload?: boolean
  preventLarge?: boolean
}

export const ProductGrid = ({
  products,
  largeCardProductIds = [],
  ratings = {},
  showVariants = false,
  preload = false,
  preventLarge = false,
}: ProductGridProps) => (
  <Container className={styles.container}>
    <div className={styles.productGrid}>
      {products?.map((product, i) => {
        const [mainVariant] = product.variants.nodes
        const variants = showVariants ? product.variants.nodes : [mainVariant]
        const preloadCard = preload && i < 2

        return variants.map((variant) => {
          const isMainVariant = variant.id === mainVariant.id
          const isOnlyOneLarge = !showVariants || (showVariants && isMainVariant)
          const showLarge = largeCardProductIds.includes(product.id) && !preventLarge && isOnlyOneLarge
          const Card = showLarge ? ProductCardLarge : ProductCard

          return (
            <Card
              product={product}
              variant={showVariants ? variant : undefined}
              rating={mainVariant.sku ? ratings[mainVariant.sku] : undefined}
              key={variant.sku}
              preload={preloadCard}
            />
          )
        })
      })}
    </div>
  </Container>
)
